import { Injectable } from '@angular/core';
import {BucketService, ImageDownloadDto} from "../../api";
import {BehaviorSubject, catchError, ReplaySubject, Subject, throwError} from "rxjs";
import {Guid} from "guid-typescript";
import {ApiHelperService} from "../api-helper-service/api-helper.service";

@Injectable({
  providedIn: 'root'
})
export class FileService {

  emptyFileSubject =  new ReplaySubject<boolean>(1)
  entryFileSubject =  new ReplaySubject<Map<string, ImageDownloadDto[]>>(1)
  entryFileCache : Map<string, ImageDownloadDto[]> =  new Map<string, ImageDownloadDto[]>();

  constructor(
    private bucketService : BucketService,
    private apiHelper : ApiHelperService

  ) { }


  loadEntryImages(entryId : string){
    this.bucketService.getDownloadUrlEndpoint(entryId)
      .subscribe((res) => {
        let img: ImageDownloadDto[] = [];
        for (const [key, value] of Object.entries(res)) {
          img.push(...value)
        }
        this.entryFileCache.set(entryId, img);
        this.entryFileSubject.next(this.entryFileCache)
      })
  }

  upload(files : File[], entryid : string, galleryKey : string){
    let ids : string[] = []
    files.forEach(f => {
      let guid = Guid.create().toString();
      ids.push(guid)
    })
    return this.bucketService.uploadFileEndpoint(JSON.stringify(ids), files, entryid, galleryKey).pipe(
      catchError((e, obs) => {
        this.apiHelper.onError(e)
        return throwError(() => e);
      }));
  }

  delete(fileId : string){
    return this.bucketService.deleteImageEndpoint({fileEntryId: fileId}).pipe(
      catchError((e, obs) => {
        this.apiHelper.onError(e)
        return throwError(() => e);
      }));
  }

  loadEmpty(){
    this.emptyFileSubject.next(true);
  }
}
